module.exports = __webpack_public_path__ + "img/CLOCK.ef2b1e4a.svg";